import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkDialog from "../../components/atoms/TkDialog";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import "./_style.scss";
import { funInfoBodyList } from "./hooks/useHooks";
import { headTitleList, searchFormList, searchFormSchema } from "./parts";
import { IAPI_ACC011_Request } from "../../type/apiType";
import { httpAPI_ACC001, httpAPI_ACC011 } from "./api/request";
import _ from "lodash";

/**
 * SCRW100003 ID・権限一覧
 * @return SCRW100003 ID・権限一覧
 */
const SCRW100003 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_101;
  const [stateSearchList, setStateSearchList] = useState(searchFormList);
  const stateList = useRef(_.cloneDeep(searchFormList));
  const [bodyListData, setBodyListData] = useState<any>([]);
  const [openSuccess, setOpenSuccess] = useState<boolean>(false);
  const [deleteUserId, setDeleteUserId] = useState<string>("");
  const [reqData, setReqData] = useState<IAPI_ACC011_Request>({});

  //リンク 押下
  const handleLink = (userId: string) => {
    navigate("/SCRW100005", { state: { userId } });
  };

  const handleRefer = async (req: any) => {
    setReqData(req);

    // 機構ユーザ一覧参照API 呼び出し
    try {
      const res = await httpAPI_ACC011({ ...req });
      setBodyListData([]);

      if (res.resultCd === "I0000") {
        setBodyListData(
          funInfoBodyList(res.wamUserList ?? [], handBtnClick, handleLink)
        );
        setState({
          ...state,
          errorMsgId: "",
        });
        setBusinessState({ job_101: { ...req } });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const clickOk = async () => {
    setOpenSuccess(false);
    if (!deleteUserId) return;

    // ユーザアカウント失効化API 呼び出し
    try {
      const res = await httpAPI_ACC001({
        userId: deleteUserId,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        handleRefer(reqData);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //初期化
  useEffect(() => {
    let resArr = stateList.current;
    for (let i in context) {
      let targetObj = resArr.find((item: any) => item.keyword === i)!;

      targetObj &&
        (targetObj.wantToSetValue = context[i as keyof typeof context]);
    }
    setStateSearchList([...resArr]);

    handleRefer(context);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * 削除ボタンクリック
   * @param userId
   */
  const handBtnClick = (userId: string) => {
    setDeleteUserId(userId);
    setOpenSuccess(true);
  };

  return (
    <Box className="SCRW100003" data-testid="SCRW100003PageForTest">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW100003_01}</TkInfoManual>
      <TkSearchForm
        listData={stateSearchList}
        ruleSchema={searchFormSchema}
        onSearch={handleRefer}
      />
      <TkDataTable
        bodyList={bodyListData}
        count={bodyListData.length}
        defaultRowsPerPage={10}
        headList={headTitleList}
        pagin
      />

      <Box className="buttonGroup">
        <TkBackButton />
      </Box>

      <TkDialog
        open={openSuccess}
        title="確認"
        contextText={`　削除を行いますが、問題ないでしょうか。`}
        okText="はい"
        cancelText="いいえ"
        onSave={clickOk}
        onCancel={() => setOpenSuccess(false)}
      />
    </Box>
  );
};

export default SCRW100003;
